const DOWNLOAD_DOUBAN_COVER_OPTION_KEY = 'option_download_douban_cover'
const DOWNLOAD_LIBBY_COVER_OPTION_KEY = 'option_download_libby_cover'
const DOWNLOAD_KOBO_COVER_OPTION_KEY = 'option_download_kobo_cover'
const DOWNLOAD_READMOO_COVER_OPTION_KEY = 'option_download_readmoo_cover'
const DOWNLOAD_CHILCHIL_COVER_OPTION_KEY = 'option_download_chilchil_cover'
const DOWNLOAD_PUBU_COVER_OPTION_KEY = 'option_download_pubu_cover'
const EDIT_REVIEW_LINK_OPTION_KEY = 'option_convert_review_links'
const SEARCH_DOUBAN_OPTION_KEY = 'option_search_douban'
const SKIP_EXISTING_AUTOFILL_OPTION_KEY = 'option_skip_existing_autofill'
const ENABLE_DOUBAN_OPTION_KEY = 'option_enable_douban'
const ENABLE_LIBBY_OPTION_KEY = 'option_enable_libby'
const ENABLE_AMAZON_OPTION_KEY = 'option_enable_amazon'
const ENABLE_KOBO_OPTION_KEY = 'option_enable_kobo'
const ENABLE_READMOO_OPTION_KEY = 'option_enable_readmoo'
const ENABLE_CHILCHIL_OPTION_KEY = 'option_enable_chilchil'
const ENABLE_PUBU_OPTION_KEY = 'option_enable_pubu'
const ENABLE_STORYGRAPH_OPTION_KEY = 'option_enable_storygraph'
const SETTINGS_MODAL_ID = 'sg-enhancer-settings-modal'

export interface UserOptions {
  enableDouban: boolean
  enableLibby: boolean
  enableAmazon: boolean
  enableKobo: boolean
  enableReadmoo: boolean
  enableChilchil: boolean
  enablePubu: boolean
  enableStoryGraph: boolean
  downloadDoubanCover: boolean
  downloadLibbyCover: boolean
  downloadKoboCover: boolean
  downloadReadmooCover: boolean
  downloadChilchilCover: boolean
  downloadPubuCover: boolean
  convertReviewLinks: boolean
  showDoubanSearchButton: boolean
  skipExistingAutofill: boolean
}

function readBooleanOption (key: string, fallback: boolean): boolean {
  const value = GM_getValue(key)
  return typeof value === 'boolean' ? value : fallback
}

function writeBooleanOption (key: string, value: boolean): void {
  GM_setValue(key, value)
}

export function getUserOptions (): UserOptions {
  return {
    enableDouban: readBooleanOption(ENABLE_DOUBAN_OPTION_KEY, true),
    enableLibby: readBooleanOption(ENABLE_LIBBY_OPTION_KEY, true),
    enableAmazon: readBooleanOption(ENABLE_AMAZON_OPTION_KEY, true),
    enableKobo: readBooleanOption(ENABLE_KOBO_OPTION_KEY, true),
    enableReadmoo: readBooleanOption(ENABLE_READMOO_OPTION_KEY, true),
    enableChilchil: readBooleanOption(ENABLE_CHILCHIL_OPTION_KEY, true),
    enablePubu: readBooleanOption(ENABLE_PUBU_OPTION_KEY, true),
    enableStoryGraph: readBooleanOption(ENABLE_STORYGRAPH_OPTION_KEY, true),
    downloadDoubanCover: readBooleanOption(DOWNLOAD_DOUBAN_COVER_OPTION_KEY, true),
    downloadLibbyCover: readBooleanOption(DOWNLOAD_LIBBY_COVER_OPTION_KEY, true),
    downloadKoboCover: readBooleanOption(DOWNLOAD_KOBO_COVER_OPTION_KEY, true),
    downloadReadmooCover: readBooleanOption(DOWNLOAD_READMOO_COVER_OPTION_KEY, true),
    downloadChilchilCover: readBooleanOption(DOWNLOAD_CHILCHIL_COVER_OPTION_KEY, true),
    downloadPubuCover: readBooleanOption(DOWNLOAD_PUBU_COVER_OPTION_KEY, true),
    convertReviewLinks: readBooleanOption(EDIT_REVIEW_LINK_OPTION_KEY, true),
    showDoubanSearchButton: readBooleanOption(SEARCH_DOUBAN_OPTION_KEY, true),
    skipExistingAutofill: readBooleanOption(SKIP_EXISTING_AUTOFILL_OPTION_KEY, true)
  }
}

function createSectionTitle (text: string): HTMLHeadingElement {
  const title = document.createElement('h4')
  title.textContent = text
  title.style.cssText = 'margin:14px 0 10px; font-size:13px; letter-spacing:0.04em; text-transform:uppercase; color:#6b7280;'
  return title
}

function createOptionToggle (labelText: string, checked: boolean): { wrapper: HTMLLabelElement, input: HTMLInputElement } {
  const wrapper = document.createElement('label')
  wrapper.style.cssText = 'display:flex; align-items:center; gap:8px; font-size:14px; color:#1f2937; margin-bottom:10px; cursor:pointer;'

  const input = document.createElement('input')
  input.type = 'checkbox'
  input.checked = checked

  const text = document.createElement('span')
  text.textContent = labelText

  wrapper.appendChild(input)
  wrapper.appendChild(text)

  return { wrapper, input }
}

function closeSettingsModal (): void {
  document.getElementById(SETTINGS_MODAL_ID)?.remove()
}

function openSettingsModal (): void {
  if (!document.body || document.getElementById(SETTINGS_MODAL_ID)) return

  const options = getUserOptions()

  const overlay = document.createElement('div')
  overlay.id = SETTINGS_MODAL_ID
  overlay.style.cssText = 'position:fixed; inset:0; background:rgba(0,0,0,0.45); z-index:100000; display:flex; align-items:center; justify-content:center;'

  const modal = document.createElement('div')
  modal.style.cssText = 'width:min(420px, calc(100vw - 24px)); background:#fff; border-radius:10px; box-shadow:0 12px 40px rgba(0,0,0,0.3); padding:18px 18px 14px; font-family:system-ui,-apple-system,sans-serif;'

  const title = document.createElement('h3')
  title.textContent = 'StoryGraph Enhancer Settings'
  title.style.cssText = 'margin:0 0 12px; font-size:18px; color:#111827;'

  const storyGraphSectionTitle = createSectionTitle('StoryGraph')
  const doubanSectionTitle = createSectionTitle('Douban')
  const libbySectionTitle = createSectionTitle('Libby')
  const amazonSectionTitle = createSectionTitle('Amazon')
  const koboSectionTitle = createSectionTitle('Kobo')
  const readmooSectionTitle = createSectionTitle('Readmoo')
  const chilchilSectionTitle = createSectionTitle('Chil-Chil')
  const pubuSectionTitle = createSectionTitle('Pubu')
  const { wrapper: enableStoryGraphWrapper, input: enableStoryGraphInput } = createOptionToggle('Enable StoryGraph functionality', options.enableStoryGraph)
  const { wrapper: enableDoubanWrapper, input: enableDoubanInput } = createOptionToggle('Enable Douban functionality', options.enableDouban)
  const { wrapper: enableLibbyWrapper, input: enableLibbyInput } = createOptionToggle('Enable Libby functionality', options.enableLibby)
  const { wrapper: enableAmazonWrapper, input: enableAmazonInput } = createOptionToggle('Enable Amazon functionality', options.enableAmazon)
  const { wrapper: enableKoboWrapper, input: enableKoboInput } = createOptionToggle('Enable Kobo functionality', options.enableKobo)
  const { wrapper: enableReadmooWrapper, input: enableReadmooInput } = createOptionToggle('Enable Readmoo functionality', options.enableReadmoo)
  const { wrapper: enableChilchilWrapper, input: enableChilchilInput } = createOptionToggle('Enable Chil-Chil functionality', options.enableChilchil)
  const { wrapper: enablePubuWrapper, input: enablePubuInput } = createOptionToggle('Enable Pubu functionality', options.enablePubu)
  const { wrapper: downloadDoubanCoverWrapper, input: downloadDoubanCoverInput } = createOptionToggle('Download Douban cover when porting', options.downloadDoubanCover)
  const { wrapper: downloadLibbyCoverWrapper, input: downloadLibbyCoverInput } = createOptionToggle('Download Libby cover when porting', options.downloadLibbyCover)
  const { wrapper: downloadKoboCoverWrapper, input: downloadKoboCoverInput } = createOptionToggle('Download Kobo cover when porting', options.downloadKoboCover)
  const { wrapper: downloadReadmooCoverWrapper, input: downloadReadmooCoverInput } = createOptionToggle('Download Readmoo cover when porting', options.downloadReadmooCover)
  const { wrapper: downloadChilchilCoverWrapper, input: downloadChilchilCoverInput } = createOptionToggle('Download Chil-Chil cover when porting', options.downloadChilchilCover)
  const { wrapper: downloadPubuCoverWrapper, input: downloadPubuCoverInput } = createOptionToggle('Download Pubu cover when porting', options.downloadPubuCover)
  const { wrapper: editReviewWrapper, input: editReviewInput } = createOptionToggle('Change review links to “edit review”', options.convertReviewLinks)
  const { wrapper: doubanSearchWrapper, input: doubanSearchInput } = createOptionToggle('Show “search douban” button on missing covers', options.showDoubanSearchButton)
  const { wrapper: skipExistingAutofillWrapper, input: skipExistingAutofillInput } = createOptionToggle('Skip autofill if fields already have text', options.skipExistingAutofill)

  const actions = document.createElement('div')
  actions.style.cssText = 'display:flex; justify-content:flex-end; gap:8px; margin-top:14px;'

  const cancelBtn = document.createElement('button')
  cancelBtn.type = 'button'
  cancelBtn.textContent = 'Cancel'
  cancelBtn.style.cssText = 'padding:6px 12px; border-radius:6px; border:1px solid #cbd5e1; background:#fff; color:#334155; cursor:pointer;'
  cancelBtn.addEventListener('click', closeSettingsModal)

  const saveBtn = document.createElement('button')
  saveBtn.type = 'button'
  saveBtn.textContent = 'Save'
  saveBtn.style.cssText = 'padding:6px 12px; border-radius:6px; border:1px solid #2e7d32; background:#2e7d32; color:#fff; cursor:pointer; font-weight:600;'
  saveBtn.addEventListener('click', () => {
    writeBooleanOption(ENABLE_STORYGRAPH_OPTION_KEY, enableStoryGraphInput.checked)
    writeBooleanOption(ENABLE_DOUBAN_OPTION_KEY, enableDoubanInput.checked)
    writeBooleanOption(ENABLE_LIBBY_OPTION_KEY, enableLibbyInput.checked)
    writeBooleanOption(ENABLE_AMAZON_OPTION_KEY, enableAmazonInput.checked)
    writeBooleanOption(ENABLE_KOBO_OPTION_KEY, enableKoboInput.checked)
    writeBooleanOption(ENABLE_READMOO_OPTION_KEY, enableReadmooInput.checked)
    writeBooleanOption(ENABLE_CHILCHIL_OPTION_KEY, enableChilchilInput.checked)
    writeBooleanOption(ENABLE_PUBU_OPTION_KEY, enablePubuInput.checked)
    writeBooleanOption(DOWNLOAD_DOUBAN_COVER_OPTION_KEY, downloadDoubanCoverInput.checked)
    writeBooleanOption(DOWNLOAD_LIBBY_COVER_OPTION_KEY, downloadLibbyCoverInput.checked)
    writeBooleanOption(DOWNLOAD_KOBO_COVER_OPTION_KEY, downloadKoboCoverInput.checked)
    writeBooleanOption(DOWNLOAD_READMOO_COVER_OPTION_KEY, downloadReadmooCoverInput.checked)
    writeBooleanOption(DOWNLOAD_CHILCHIL_COVER_OPTION_KEY, downloadChilchilCoverInput.checked)
    writeBooleanOption(DOWNLOAD_PUBU_COVER_OPTION_KEY, downloadPubuCoverInput.checked)
    writeBooleanOption(EDIT_REVIEW_LINK_OPTION_KEY, editReviewInput.checked)
    writeBooleanOption(SEARCH_DOUBAN_OPTION_KEY, doubanSearchInput.checked)
    writeBooleanOption(SKIP_EXISTING_AUTOFILL_OPTION_KEY, skipExistingAutofillInput.checked)
    closeSettingsModal()
  })

  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) closeSettingsModal()
  })

  actions.appendChild(cancelBtn)
  actions.appendChild(saveBtn)

  modal.appendChild(title)
  modal.appendChild(storyGraphSectionTitle)
  modal.appendChild(enableStoryGraphWrapper)
  modal.appendChild(editReviewWrapper)
  modal.appendChild(doubanSearchWrapper)
  modal.appendChild(skipExistingAutofillWrapper)
  modal.appendChild(doubanSectionTitle)
  modal.appendChild(enableDoubanWrapper)
  modal.appendChild(downloadDoubanCoverWrapper)
  modal.appendChild(libbySectionTitle)
  modal.appendChild(enableLibbyWrapper)
  modal.appendChild(downloadLibbyCoverWrapper)
  modal.appendChild(amazonSectionTitle)
  modal.appendChild(enableAmazonWrapper)
  modal.appendChild(koboSectionTitle)
  modal.appendChild(enableKoboWrapper)
  modal.appendChild(downloadKoboCoverWrapper)
  modal.appendChild(readmooSectionTitle)
  modal.appendChild(enableReadmooWrapper)
  modal.appendChild(downloadReadmooCoverWrapper)
  modal.appendChild(chilchilSectionTitle)
  modal.appendChild(enableChilchilWrapper)
  modal.appendChild(downloadChilchilCoverWrapper)
  modal.appendChild(pubuSectionTitle)
  modal.appendChild(enablePubuWrapper)
  modal.appendChild(downloadPubuCoverWrapper)
  modal.appendChild(actions)

  overlay.appendChild(modal)
  document.body.appendChild(overlay)
}

export function registerOptionMenu (): void {
  if (typeof GM_registerMenuCommand !== 'function') return

  GM_registerMenuCommand('⚙️ StoryGraph Enhancer settings', openSettingsModal)
}
